module.exports = __webpack_public_path__ + "static/media/number-list.eaea0a19.svg";